import { SplitLayout } from '@components/layout';
import { AuthenticationHeader } from '@components/layout/authentication/AuthenticationHeader';
import { useAuth } from '@hooks/useAuth';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SetNewPasswordForm } from './SetNewPasswordForm';

const SetNewPassword = () => {
    const { isUserLoading } = useAuth();

    if (isUserLoading) {
        return (
            <FormattedMessage
                id="common.loading"
                defaultMessage="Loading..."
                description="Loading message for usage while loading data in a page"
            />
        );
    }

    return (
        <>
            <title>Victron Professional - Set New Password</title>
            <SplitLayout>
                <div className="flex flex-col w-full">
                    <AuthenticationHeader />
                    <Alert severity="info" icon={<InfoOutlinedIcon color="info-main" />}>
                        <Typography fontFamily="Roboto" fontWeight={500} fontSize={16}>
                            <FormattedMessage
                                id="auth.setNewPassword.title"
                                defaultMessage="Set your new password"
                                description="Title for password reset page. Used in: /auth/set-new-password"
                            />
                        </Typography>
                        <Typography fontFamily="Roboto" fontWeight={400} fontSize={14} mt={1}>
                            <FormattedMessage
                                id="auth.setNewPassword.description"
                                defaultMessage="You can set your new password with the form below. When you are done you will be able to login with this new password."
                                description="Instructions for setting new password. Used in: /auth/set-new-password"
                            />
                        </Typography>
                    </Alert>
                    <SetNewPasswordForm />
                </div>
            </SplitLayout>
        </>
    );
};

export { SetNewPassword };
